import FormActions from 'components/Form/FormActions';
import FormResult from 'components/Form/FormResult';
import SubmitButton from 'components/Form/SubmitButton';
import PageLayout from 'components/PageLayout';
import {FC, useState} from 'react';
import {FormProvider, useForm} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {t} from 'ttag';
import {Backend} from 'types/api';
import {onApiError} from 'utils/request-axios/utils';

import RegistrationCompleted from '../components/RegistrationCompleted';
import usePostVerifyEmail from './services';
export type EmailRegistrationSuccessBackend = Backend<{
    clientName: string;
    code: string;
    confirmed: boolean;
    email: string;
    instructionUrl: string | undefined;
    partnerName: string;
    token: string;
}>;

const EmailRegistrationSuccess: FC = () => {
    const {data} = useBackend<EmailRegistrationSuccessBackend>();

    const [confirmed, setConfirmed] = useState(data.confirmed);
    const methods = useForm();
    const verifyEmail = usePostVerifyEmail();

    const handleSubmit = async () => {
        await verifyEmail
            .mutateAsync({code: data.code, token: data.token})
            .then(() => {
                setConfirmed(true);
            })
            .catch(onApiError(methods));
    };
    return (
        <PageLayout
            headerProps={{
                className: 'pb-3 sm:mt-[15vh] pl-6 sm:pl-2',
                showLanguage: window.innerWidth > 640,
            }}
        >
            <div className="items-center px-2 sm:px-0">
                <div className="rounded-lg border border-grey-300 bg-white p-2 pb-4 shadow-lg sm:p-6">
                    {confirmed ? (
                        <RegistrationCompleted
                            clientName={data.clientName}
                            email={data.email}
                            instructionUrl={data.instructionUrl}
                            partnerName={data.partnerName}
                        />
                    ) : (
                        <FormProvider {...methods}>
                            <form onSubmit={methods.handleSubmit(handleSubmit)}>
                                <h1 className="mt-2 flex ">{t`Welcome to Email Address Registration`}</h1>
                                <p className="pb-4 text-base">
                                    {t`We noticed this is the first time you’re using this browser to access Email Address Registration. Please click Proceed to continue.`}
                                </p>
                                <FormActions>
                                    <SubmitButton
                                        disabled={verifyEmail.isPending}
                                        type="submit"
                                    >{t`Proceed`}</SubmitButton>
                                </FormActions>
                                <FormResult className="mt-4" />
                            </form>
                        </FormProvider>
                    )}
                </div>
            </div>
        </PageLayout>
    );
};

export default EmailRegistrationSuccess;
